import wixLocation from 'wix-location';
import { fireBIEvent } from 'public/bi-event.js';

$w.onReady(function () {
    clickOnSecondaryCtaBiEvent()
    watchVideoBiEvent()
});

const clickOnSecondaryCtaBiEvent = () => {

    const ctasA = [{
            btnBoxId: '#box2',
            id: '#WatchMoreVideosButton',
            cta_category: 'Get Started With Wix Editor',
            cta_name: $w('#watchMore').label,
            target_url: $w('#watchMore').link
        },
        {
            btnBoxId: '#box1',
            id: '#GoToGuideButton',
            cta_category: 'Find More Resources',
            cta_name: $w('#goToGuide').label,
            target_url: $w('#goToGuide').link
        },
    ]
    ctasA.forEach((cta) => {

        const {
            btnBoxId,
            id,
            cta_category,
            cta_name,
            target_url,
        } = cta;
        console.log(cta);
        $w(btnBoxId).onClick(() => {

            const biFields = {
                id,
                btnBoxId,
                cta_category,
                cta_name,
                target_url,

            }
            fireBIEvent(19, 9002, biFields);
        });
    });
}

const watchVideoBiEvent = () => {

    const biFields = {
        video_name: 'Webinar: Get Strted With Wix',
        video_url: 'http://www.youtube.com/watch?v=tppDIxx7cuA',
        page_url: wixLocation.url,
    }

    $w('#videoPlayer1').onPlay(() => {
        fireBIEvent(19, 9100, biFields);

    });

    let twentySecondFlag = false;
    let fiftyPercentFlag = false;
    let ninetyPercentFlag = false;
    $w('#videoPlayer1').onProgress((e) => {
        let currentTime = e.target.currentTime;
        let duration = e.target.duration;
        if (currentTime > 20 && !twentySecondFlag) {
            fireBIEvent(19, 9101, biFields)
            twentySecondFlag = true;
            console.log('20 sec')
        }
        if (duration / currentTime < 2 && !fiftyPercentFlag) {
            fireBIEvent(19, 9102, biFields);
            fiftyPercentFlag = true;
            console.log('50 percent')
        }
        if (currentTime / duration >= 0.9 && !ninetyPercentFlag) {
            fireBIEvent(19, 9103, biFields);
            ninetyPercentFlag = true;
            console.log('90 percent')
        }

    })
};